module.exports = __webpack_public_path__ + "media/recipes/44-a90bd737.png";